import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import WinImg from "../../../../ebusHomePics/win.png";
import HowImg from "../../../../ebusHomePics/How.png";
import Fieldz from "../../../../functions/Fieldz";
import { createMuiTheme, MuiThemeProvider, } from "@material-ui/core";
import "../EbusRecomended.css";
import CardItem from "./CardItem";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import Axios from "axios";
import config from "../../../../config/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ToastContainer, toast } from "react-toastify";

const BtnContain = styled.div`
    width: 100%;
    padding: 20px;
    display: inline-grid;
    justify-content: center;
    align-items: center;
    margin-top:  0px;
`;

const Button = styled.button`
    width: 25rem;
    padding: 15px;
    background-color: #6dd06d;
    border: none;
    border-radius: 15px;    
    text-align: center;
    margin-top: 15px;
    color: white;
    font-weight: bold;
    margin-left: 10px;
`;

const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid ${(props) => props.color};
  justify-content: between;
  margin: 0 auto;
  margin-top: -25px;

`;

const ModalContain = styled.div`
  width: 100% !important;
  height: 22rem; 
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-top: 25px;
`;

const IConContainer = styled.div`
    top: -15%;
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
`;

const Logo = styled.img`
    margin-left: auto;
    margin-right: auto;
    max-width: 150px;
    max-height: 150px;
`;

const Head = styled.h1`
  font-weight: bold;
  text-align: center;
  color: #7d7d80;
`;

const DisCountDiv = styled.div`
  width: 100%;
  height: 100px;
  display: column;
  justify-content: center;
  align-items: center;
`;

const FootModal = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 20px;
`;

export default () => {
  const muiTheme = createMuiTheme({
    overrides: {
      MuiSvgIcon: {
        root: {
          fontSize: "2.5rem",
          color: "#6dd06d",
        },
      },
      MuiIconButton: {
        label: {
          borderRadius: "50%",
          backgroundColor: "white",
        },
      },
    },
  });
  const teams = [
    {
      id: 1,
      title: " سوپرایز ایباس",
      t1: "یک سفر رایگان",
      t2: "سفر با ۷۰ درصد تخفیف",
      enTitle: "Spain",
    },
    {
      id: 2,
      title: " بلیط اول رو بخر, بلیط دوم رو با نصف قیمت بخر",
      enTitle: "Spain",
    },
    {
      id: 3,
      title: "تخفیف %25 سفر با ایباس",
      enTitle: "Spain",
    },
    {
      id: 4,
      title: "همسفرت مهمون ایباس",
      enTitle: "Spain",
    },
  ];

  // const [phone, setPhone] = useState(null)
  const [card, setCard] = useState(-1)
  const [openModal, setOpenModal] = useState(false)
  const toastId = useRef(null);

  const discounts = [
    { id: 0, discountCode: 'ebus-s1', discountValue: 720000, discountType: 1, limit: 50 }, // سفر رایگان
    { id: 1, discountCode: 'ebus-s2', discountValue: 70, discountType: 0, limit: 50 }, // سفر ۷۰ درصد
    { id: 2, discountCode: 'ebus-rb', discountValue: 25, discountType: 0, limit: 100 }, // بلیط اول بخر. بلیط دوم نصف قیمت
    { id: 3, discountCode: 'ebus-25', discountValue: 25, discountType: 0, limit: 100 }, // تخفیف ۲۵ درصد
    { id: 4, discountCode: 'ebus-h2', discountValue: 50, discountType: 0, limit: 50 }, // همسفر
  ]

  const getCard = (cardId) => {
    console.log('card in Parent Component: ', cardId + 1);
    setCard(cardId + 1)
  }

  const handleSubmitButton = (phone) => {

    if (card == -1) {
      toast.error("لطفا یکی از گزینه ها را انتخاب کنید")
      return;
    } else if (phone === undefined) {
      toast.error("لطفا شماره تلفن را وارد کنید.")
      return;
    }

    if (card === 1) {
      const rnd = Math.floor(Math.random() * (1 - 0 + 1) + 0);
      setCard(rnd);

    } else {
      setCard(card)
    }

    // send to server
    const data = {
      phone: phone,
      discountCodeId: card,
      campaignId: 1,
    }
    const res = Axios.post(config.baseUrl + "Campaign/createUser", data)
      .then((res) => {
        if (res.status === 201) {
          toast.success("کد تخفیف برای شما ثبت شد")
          setOpenModal(true)
        }
        console.log(res);
      })
      .catch((error) => {
        toast.error("شما قبلا ثبت نام شده اید");
        console.log(error)
      })
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  }

  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className="er-parent-div">
        <div className="row er-green-section">
          <div className="er-img-div">
            <img src={WinImg} className="er-win-img" />
            <div style={{ marginInline: 60 }}>
              <h3 className="er-bread-txt">
                <b style={{ fontSize: 24 }}>ایباس</b> یک شرکت حمل و نقل اتوبوسیه
                که به تازگی شروع به کار تو مسیرِخط{" "}
                <b> رشت به تهران و تهران به رشت </b>
                کرده. اگه مسافر <b>
                  {" "}
                  خط اتوبوسی رشت به تهران و تهران به رشت{" "}
                </b>{" "}
                هستی چندتا پیشنهاد جذاب داریم برات، می تونی{" "}
                <b> بدون قرعه کشی برنده جایزه بشی !! </b>
              </h3>
            </div>

            <div className="row er-orange-section" style={{ marginTop: 75 }}>
              <div className="er-img-div">
                <img src={HowImg} className="er-how-img" />
                <div style={{ marginInline: 60 }}>
                  <h3 className="er-bread-txt">
                    <p>شماره تماست رو وارد کن</p>
                    <p>یکی از ۴ گزینه زیر رو برای دریافت جایزه انتخاب کن</p>
                  </h3>
                </div>
              </div>
            </div>

            <Formik
              enableReinitialize
              initialValues={{}}
              onSubmit={(values) => {
                console.log("cardId", card)
                handleSubmitButton(values.phone);
              }}
            >
              {({ handleSubmit, setFieldValue, errors, touched }) => {
                return (
                  <>

                    <div className="ebus-fields-div">
                      <ArrowDown color={"rgb(239 178 67)"} />

                      <ToastContainer
                        position="top-right"
                        autoClose={10000}
                        closeOnClick
                        rtl={true}
                        pauseOnHover
                      />

                      <Modal
                        show={openModal}
                        onHide={handleCloseModal}
                        size="lg"
                        dialogClassName={"primaryModal"}
                        // aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title id="contained-modal-title-vcenter" >
                            <IConContainer>
                              <Logo src={toAbsoluteUrl("./media/logos/prize.png")}></Logo>
                            </IConContainer>
                            <ModalContain>
                              <Head>
                                هدیه ایباس به شما
                                <br />
                                <br />
                                <div style={{ backgroundColor: "#e5e5e5", borderRadius: "10px", padding: "10px" }}>
                                  <h4 style={{ color: "#7d7d80" }}>برو به سایت ایباس و موقع خرید بلیط این کد تخفیف رو وارد کن.</h4>
                                  <br />
                                  <br />
                                  <h1 style={{ fontWeight: "bold", color: "#7d7d80" }}>
                                    {card !== 0 && card !== 1 ? teams[card - 1]?.title : ''}
                                    {card === 0 ? teams[0].t1 : ''}
                                    {card === 1 ? teams[0].t2 : ''}
                                    <br />
                                    <br />
                                    {discounts.at(card).discountCode}
                                  </h1>
                                  <br />
                                  <br />
                                </div>
                              </Head>
                            </ModalContain>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                          <FootModal>
                            <h6 style={{ marginRight: "30px", marginLeft: "30px", marginBottom: "70px" }}>این پیشنهاد ایباس رو با کسایی که میشناسی به اشتراک بذار تااونها هم از تخفیفاتمون بهرمند بشن</h6>
                            <Button
                              className="btn"
                              // variant="primary"
                              onClick={() => window.location.href = "https://www.ebus.ir"}
                            >
                              الان بلیطت رو بخر
                            </Button>
                            <Button
                              className="btn btn-secondary"
                              // variant="Secondary"
                              onClick={() => {
                                handleCloseModal();
                              }}
                            >
                              اشتراک گذاری
                            </Button>

                          </FootModal>
                        </Modal.Footer>
                      </Modal>

                      <div className="row">
                        {Fieldz({
                          name: "phone",
                          placeholder: "شماره موبایل",
                          customCol: "col-12 col-md-6 col-lg-4",
                          label: "شماره تماس:",
                          labelClassName: "er-phoneNumber-label",
                          setValue: setFieldValue,
                          type: "text",
                          errors,
                          touched,
                        })}

                        {/* <Input name="phone"/> */}
                        <h6 className="er-options-label col-12">
                          یکی از گزینه ها رو انتخاب کن:
                        </h6>
                        <CardItem title="Pick a team" cardContents={teams} onGetCard={getCard} />
                      </div>

                    </div>
                    <BtnContain className="row justify-content-center">
                      <ArrowDown color={"white"} />
                      <span className="text-center font-15" style={{ color: "#7d7d80", marginTop: "20px" }}>ثبت رو بزن و هدیه ت رو دریافت کن</span>
                      <Button type="submit" onClick={() => handleSubmit()}
                      >
                        ثبت
                      </Button>
                    </BtnContain>
                  </>
                );
              }}

            </Formik>

          </div>
        </div>
      </div>
    </MuiThemeProvider >
  );
};
